module.exports = __webpack_public_path__ + "img/mobile-48.eb34f329.png";